<app-aaos-spinner [isLoading]="prepopulating"></app-aaos-spinner>
<div *ngIf="!prepopulating">
  <app-aaos-residency-program [applicationCountries]="applicationCountries" [formOptions]="formOptions" *ngFor="let residencyProgram of residencyProgramDetails" [dynamicForm] = "dynamicForm" [residencyProgramDetail]="residencyProgram" (componentChanged)="onComponentChange($event)" [fieldsPrerequisite]="fieldsPrerequisite"></app-aaos-residency-program>
</div>
<button class="btn btn--solid" (click)="addInstitution()">ADD RESIDENCY</button>
